import { USER_TYPE } from 'app/config/users';
import { PAD_VISIT_TYPE } from 'app/config/padVisits';
import { VISITATION_TYPE_TEMPLATE } from 'app/config/visitationTypeTemplate';
// import { CBOCODE } from 'app/config/profession';
// import { FREQUENCY } from 'app/config/frequency_type';
// import { codeGeneretor } from 'app/utils';
import { createCalendarVisitSchedule } from './calendarVisitSchedule.schema.js';
import {
  VISIT_SCHEDULE_KEYS,
  NORMALIZED_KEYS
} from 'app/redux/features/pad-initialization/reducer/visit-schedule-step/visitScheduleStep.reducer';

const isSuspensionVisit = padVisit => {
  const { padVisitType } = padVisit;
  const isSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;

  return isSuspension;
};

const isImplantationVisit = padVisit => {
  const { visitationType } = padVisit;
  const { visitationTypeTemplate = {} } = visitationType;
  const templateId = visitationTypeTemplate.id || null;
  const isImplantation = templateId === VISITATION_TYPE_TEMPLATE.IMPLANTATION;

  return isImplantation;
};

const isClient = padVisit => {
  const { responsibleType } = padVisit;
  return responsibleType === USER_TYPE.HOMECARE;
};

const isCooperative = padVisit => {
  const { responsibleType } = padVisit;
  return responsibleType === USER_TYPE.COOPERATIVE;
};

const hasLinkWithPadPrescription = padVisit => {
  const { padPrescriptions = [] } = padVisit;
  return Array.isArray(padPrescriptions) && padPrescriptions.length > 0;
};

export const shouldIncludeAsCalendarVisitScheduleCooperative = padVisit => {
  return (
    isCooperative(padVisit) && !isSuspensionVisit(padVisit) && !hasLinkWithPadPrescription(padVisit)
  );
};

export const shouldIncludeAsVisitPrescriptionScheduleCooperative = padVisit => {
  return (
    isCooperative(padVisit) && !isSuspensionVisit(padVisit) && hasLinkWithPadPrescription(padVisit)
  );
};

// /**
//  * Business rules for determining if a padVisit should become a genericVisit.
//  * Centralizes all filtering logic for testability and reusability.
//  */
// export const shouldIncludeAsCalendarVisitSchedule = (padVisit, context) => {
//   const { responsibleType, padVisitType, visitationType } = padVisit;

//   const isSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;

//   const templateId =
//     visitationType.visitationTypeTemplate && visitationType.visitationTypeTemplate.id
//       ? visitationType.visitationTypeTemplate.id
//       : null;
//   const isImplantation = templateId === VISITATION_TYPE_TEMPLATE.IMPLANTATION;

//   const isClient = responsibleType === USER_TYPE.HOMECARE;
//   const isCooperative = responsibleType === USER_TYPE.COOPERATIVE;

//   const isResponsibleMatch = context.userType === USER_TYPE.HOMECARE ? isClient : isCooperative;

//   if (isSuspension) return false;
//   if (!isResponsibleMatch) return false;
//   if (context.userType === USER_TYPE.HOMECARE && isImplantation) return false;

//   return true;
// };

/**
 * Business rules for determining if a padVisit should become a genericVisit.
 * Centralizes all filtering logic for testability and reusability.
 */
export const shouldIncludeAsCalendarVisitSchedule = (padVisit, context) => {
  const isSuspension = isSuspensionVisit(padVisit);
  const isImplantation = isImplantationVisit(padVisit);
  const isHomecare = isClient(padVisit);

  if (isSuspension) return false;
  if (!isHomecare) return false;
  if (context.userType === USER_TYPE.HOMECARE && isImplantation) return false;

  return true;
};

export const shouldIncludeAsSuspensionVisits = padVisit => {
  const { padVisitType } = padVisit;

  const isPadVisitSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;

  return isPadVisitSuspension;
};

// export const shouldIncludeAsDailySchedule = padVisit => {
//   const { frequencyId, profession } = padVisit;

//   // técnico de enfermagem (322205)
//   const isProfessionNursingTechnician = profession.CBOCode === CBOCODE.NURSING_TECHNICIAN;

//   //  frequência "vezes por dia"
//   const isDailyFrequency = frequencyId === FREQUENCY.DAY_ID;

//   return isProfessionNursingTechnician && isDailyFrequency;
// };

/**
 * Transforms a single padVisit into a genericVisit structure.
 * Pure function with no side effects.
 */
export const transformPadVisitToCalendarVisitSchedule = padVisit =>
  createCalendarVisitSchedule(padVisit);

/**
 * Filters and transforms an array of padVisits based on context.
 */
export const filterAndTransformPadVisitsToCalendarVisitSchedule = (padVisits, context) => {
  if (!Array.isArray(padVisits)) return [];

  return padVisits
    .filter(padVisit => shouldIncludeAsCalendarVisitSchedule(padVisit, context))
    .map(transformPadVisitToCalendarVisitSchedule);
};

// const buildDailyScheduleFormVisit = () => {
//   return {
//     code: codeGeneretor(),
//     professionalId: null,
//     startDate: null,
//     workSchedule: null,
//     period: null,
//     workShift: null
//   };
// };

// const buildDailyScheduleObj = padVisit => {
//   return {
//     padVisit,
//     formVisits: [buildDailyScheduleFormVisit()]
//   };
// };

/**
 * Normalizes an array of prescriptions grouped by padVisitId.
 * Each visit contains its own normalized collection of prescriptions.
 */
export const normalizeVisitPrescriptionSchedule = visitPrescriptionScheduleArray => {
  const byPadVisitId = {};
  visitPrescriptionScheduleArray.forEach(schedule => {
    const id = schedule.padVisitId;
    if (id) {
      byPadVisitId[id] = createCalendarVisitSchedule(schedule);
    }
  });
  return {
    ids: Object.keys(byPadVisitId).map(Number),
    byPadVisitId
  };
};
/**
 * Normalizes an object of prescriptions grouped by padVisitId.
 * @param {Object} visitPrescriptionScheduleObject - The input object where keys are IDs and values are schedule data.
 */
export const normalizeVisitPrescriptionScheduleFromObject = visitPrescriptionScheduleObject => {
  const byPadVisitId = {};

  const id = visitPrescriptionScheduleObject.padVisitId;
  if (id) {
    byPadVisitId[id] = createCalendarVisitSchedule(visitPrescriptionScheduleObject);
  }

  return {
    ids: Object.keys(byPadVisitId).map(Number),
    byPadVisitId
  };
};

/**
 * Creates a new calendar state with filtered entries by removing specified padVisitIds.
 * @param {Object} state - Current state
 * @param {string[]} padVisitIdsToRemove - Array of padVisitIds to remove
 * @returns {Object} New calendar state with filtered entries
 */
const createFilteredCalendarState = (state, padVisitIdsToRemove) => {
  const calendarState = state[VISIT_SCHEDULE_KEYS.CALENDAR];

  const byPadVisitId = calendarState[NORMALIZED_KEYS.BY_PAD_VISIT_ID] || {};
  const padVisitIds = calendarState[NORMALIZED_KEYS.IDS] || [];

  const filteredByPadVisitId = padVisitIds
    .filter(padVisitId => !padVisitIdsToRemove.includes(padVisitId))
    .reduce((result, padVisitId) => {
      result[padVisitId] = byPadVisitId[padVisitId];
      return result;
    }, {});

  return {
    ...calendarState,
    [NORMALIZED_KEYS.BY_PAD_VISIT_ID]: filteredByPadVisitId,
    [NORMALIZED_KEYS.IDS]: padVisitIds.filter(
      padVisitId => !padVisitIdsToRemove.includes(padVisitId)
    )
  };
};

/**
 * Creates a new daily state with filtered entries by removing specified padVisitIds.
 * @param {Object} state - Current state
 * @param {string[]} padVisitIdsToRemove - Array of padVisitIds to remove
 * @returns {Object} New daily state with filtered entries
 */
const createFilteredDailyState = (state, padVisitIdsToRemove) => {
  const dailyState = state[VISIT_SCHEDULE_KEYS.DAILY];
  const byPadVisitId = dailyState[NORMALIZED_KEYS.BY_PAD_VISIT_ID] || {};
  const padVisitIds = dailyState[NORMALIZED_KEYS.IDS] || [];

  const filteredByPadVisitId = padVisitIds
    .filter(padVisitId => !padVisitIdsToRemove.includes(padVisitId))
    .reduce((result, padVisitId) => {
      result[padVisitId] = byPadVisitId[padVisitId];
      return result;
    }, {});

  return {
    ...dailyState,
    [NORMALIZED_KEYS.BY_PAD_VISIT_ID]: filteredByPadVisitId,
    [NORMALIZED_KEYS.IDS]: padVisitIds.filter(
      padVisitId => !padVisitIdsToRemove.includes(padVisitId)
    )
  };
};

/**
 * Handles missing padVisits that need to be added to either calendar or daily schedules.
 * @param {Object} state - Current state
 * @param {Object} newCalendarState - Filtered calendar state
 * @param {Object} newDailyState - Filtered daily state
 * @param {Array} schedulesToAdd - Schedules that need to be added
 * @returns {Object} Object with newCalendarVisitSchedule and newVisitDailySchedule
 */
const handleMissingPadVisits = (state, newCalendarState, newDailyState, schedulesToAdd) => {
  let mergedCalendarIds = [...(newCalendarState[NORMALIZED_KEYS.IDS] || [])];
  let mergedCalendarByPadVisitId = { ...(newCalendarState[NORMALIZED_KEYS.BY_PAD_VISIT_ID] || {}) };

  let mergedDailyIds = [...(newDailyState[NORMALIZED_KEYS.IDS] || [])];
  let mergedDailyByPadVisitId = { ...(newDailyState[NORMALIZED_KEYS.BY_PAD_VISIT_ID] || {}) };

  schedulesToAdd.forEach(schedule => {
    const { padVisit } = schedule;
    const padVisitId = padVisit.id;

    const shouldIncludeAsCalendar = shouldIncludeAsCalendarVisitSchedule(padVisit, {
      userType: USER_TYPE.HOMECARE
    });

    if (shouldIncludeAsCalendar) {
      if (!mergedCalendarIds.includes(padVisitId) && !newCalendarState.byPadVisitId[padVisitId]) {
        mergedCalendarIds.push(padVisitId);
        mergedCalendarByPadVisitId[padVisitId] = schedule;
      }
    } else {
      if (!mergedDailyIds.includes(padVisitId) && !newDailyState.byPadVisitId[padVisitId]) {
        mergedDailyIds.push(padVisitId);
        mergedDailyByPadVisitId[padVisitId] = schedule;
      }
    }
  });

  return {
    newCalendarVisitSchedule: {
      ...newCalendarState,
      [NORMALIZED_KEYS.IDS]: mergedCalendarIds,
      [NORMALIZED_KEYS.BY_PAD_VISIT_ID]: mergedCalendarByPadVisitId
    },
    newVisitDailySchedule: {
      ...newDailyState,
      [NORMALIZED_KEYS.IDS]: mergedDailyIds,
      [NORMALIZED_KEYS.BY_PAD_VISIT_ID]: mergedDailyByPadVisitId
    }
  };
};

/**
 * Creates a new event with updated padPrescriptionIds array.
 * @param {Object} event - The event object
 * @param {number} prescriptionId - The prescription ID to add/remove
 * @param {boolean} shouldAdd - true to add, false to remove
 * @returns {Object} New event with updated padPrescriptionIds
 */
const updateEventPadPrescriptionIds = (event, prescriptionId, shouldAdd) => {
  if (!event) return event;

  const currentIds = Array.isArray(event.padPrescriptionIds) ? event.padPrescriptionIds : [];

  let newIds;
  if (shouldAdd) {
    // Add only if not already present
    newIds = currentIds.includes(prescriptionId) ? currentIds : [...currentIds, prescriptionId];
  } else {
    // Remove if present
    newIds = currentIds.filter(id => id !== prescriptionId);
  }

  return {
    ...event,
    padPrescriptionIds: newIds
  };
};

/**
 * Updates all events in a schedule based on padVisitId comparison.
 * @param {Object} schedule - The schedule object
 * @param {number} prescriptionId - The prescription ID
 * @param {number|string|null} sourcePadVisitId - The padVisitId from the prescription
 * @returns {Object} New schedule with updated events
 */
const updateScheduleEvents = (schedule, prescriptionId, sourcePadVisitId) => {
  if (!schedule || !Array.isArray(schedule.events)) {
    return schedule;
  }

  const schedulePadVisitId = schedule.padVisitId;
  const hasMatchingPadVisitId =
    sourcePadVisitId !== null &&
    sourcePadVisitId !== undefined &&
    schedulePadVisitId === sourcePadVisitId;

  const shouldAdd = hasMatchingPadVisitId;

  const updatedEvents = schedule.events.map(event =>
    updateEventPadPrescriptionIds(event, prescriptionId, shouldAdd)
  );

  return {
    ...schedule,
    events: updatedEvents
  };
};

/**
 * Updates padPrescriptionIds in events across all three collections
 * (calendar, daily, prescription) based on the prescriptions array.
 * @param {Object} state - State after schedule movement
 * @param {Array} prescriptionsArray - Array of valid prescriptions with id and padVisitId
 * @returns {Object} State with updated event padPrescriptionIds
 */
const updateAllCollectionsPadPrescriptionIds = (state, prescriptionsArray) => {
  // Helper to update a single collection's events
  const updateCollectionEvents = collection => {
    if (!collection || !collection.byPadVisitId) {
      return collection;
    }

    const updatedByPadVisitId = { ...collection.byPadVisitId };

    Object.keys(updatedByPadVisitId).forEach(padVisitId => {
      const schedule = updatedByPadVisitId[padVisitId];
      let updatedSchedule = { ...schedule };

      // Process each prescription to determine if it should be added/removed
      prescriptionsArray.forEach(prescription => {
        const { id: prescriptionId, padVisitId: sourcePadVisitId } = prescription;

        if (prescriptionId === undefined || prescriptionId === null) {
          return;
        }

        updatedSchedule = updateScheduleEvents(updatedSchedule, prescriptionId, sourcePadVisitId);
      });

      updatedByPadVisitId[padVisitId] = updatedSchedule;
    });

    return {
      ...collection,
      byPadVisitId: updatedByPadVisitId
    };
  };

  return {
    ...state,
    [VISIT_SCHEDULE_KEYS.CALENDAR]: updateCollectionEvents(state.calendarVisitSchedule),
    [VISIT_SCHEDULE_KEYS.DAILY]: updateCollectionEvents(state.calendarDailySchedules),
    [VISIT_SCHEDULE_KEYS.PRESCRIPTION]: updateCollectionEvents(state.visitPrescriptionSchedules)
  };
};

/**
 * Computes the new state for calendar, daily, and prescription schedules
 * based on the provided prescriptions array. Pure function with no side effects.
 * Maintains existing behavior (moving schedules between collections) AND
 * updates padPrescriptionIds in events throughout all collections.
 * @param {Object} state - Current state
 * @param {Array} prescriptionsArray - Array of all prescriptions schedule objects
 * @returns {Object} Object with state keys (calendarVisitSchedule, calendarDailySchedules, visitPrescriptionSchedules)
 */
export const computeUpdateSchedulePrescriptionState = (state, prescriptionsArray) => {
  // Validate and handle empty array case
  if (!Array.isArray(prescriptionsArray) || prescriptionsArray.length === 0) {
    return {
      [VISIT_SCHEDULE_KEYS.CALENDAR]: state.calendarVisitSchedule,
      [VISIT_SCHEDULE_KEYS.DAILY]: state.calendarDailySchedules,
      [VISIT_SCHEDULE_KEYS.PRESCRIPTION]: {
        ids: [],
        byPadVisitId: {}
      }
    };
  }

  // Validate structure - all items must have at least an id
  const validPrescriptions = prescriptionsArray.filter(item => item && item.id !== null);

  if (validPrescriptions.length === 0) {
    return {
      [VISIT_SCHEDULE_KEYS.CALENDAR]: state.calendarVisitSchedule,
      [VISIT_SCHEDULE_KEYS.DAILY]: state.calendarDailySchedules,
      [VISIT_SCHEDULE_KEYS.PRESCRIPTION]: state.visitPrescriptionSchedules
    };
  }

  const allSchedules =
    [
      ...Object.values(state.calendarVisitSchedule.byPadVisitId || {}).filter(Boolean),
      ...Object.values(state.calendarDailySchedules.byPadVisitId || {}).filter(Boolean),
      ...Object.values(state.visitPrescriptionSchedules.byPadVisitId || {}).filter(Boolean)
    ]
      .filter(Boolean)
      // Reset Events
      .map(schedule => ({ ...schedule, events: [] }))
      // Reset PrescriptionLoadSchedule
      .map(schedule => ({ ...schedule, prescriptionLoadSchedule: [] })) || [];

  const padVisitIdsToAddInVisitPrescriptionSchedule = prescriptionsArray
    .filter(({ padVisitId }) => !!padVisitId)
    .map(({ padVisitId }) => padVisitId);

  const scheduleToAddInVisitPrescriptionSchedule = allSchedules.filter(schedule =>
    padVisitIdsToAddInVisitPrescriptionSchedule.includes(schedule.padVisitId)
  );

  const scheduleToRemoveFromVisitPrescriptionSchedule = allSchedules.filter(
    schedule => !padVisitIdsToAddInVisitPrescriptionSchedule.includes(schedule.padVisitId)
  );

  const padVisitIdsToRemove = scheduleToAddInVisitPrescriptionSchedule.map(
    ({ padVisitId }) => padVisitId
  );

  const schedulesToAdd = [...scheduleToRemoveFromVisitPrescriptionSchedule];

  // Create new state visit prescription schedules
  const newVisitPrescriptionSchedule = normalizeVisitPrescriptionSchedule(
    scheduleToAddInVisitPrescriptionSchedule
  );

  // Create new state with filtered calendar and daily schedules (remove prescription-related entries)
  const filteredCalendarVisitSchedule = createFilteredCalendarState(state, padVisitIdsToRemove);
  const filteredCalendarDailySchedule = createFilteredDailyState(state, padVisitIdsToRemove);

  // Handle padVisits not in prescriptionsArray
  const { newCalendarVisitSchedule, newVisitDailySchedule } = handleMissingPadVisits(
    state,
    filteredCalendarVisitSchedule,
    filteredCalendarDailySchedule,
    schedulesToAdd
  );

  // STEP 1: Build intermediate state with schedules in their correct collections
  const intermediateState = {
    ...state,
    [VISIT_SCHEDULE_KEYS.CALENDAR]: newCalendarVisitSchedule,
    [VISIT_SCHEDULE_KEYS.DAILY]: newVisitDailySchedule,
    [VISIT_SCHEDULE_KEYS.PRESCRIPTION]: newVisitPrescriptionSchedule
  };

  // STEP 2: Update padPrescriptionIds in events across all collections
  const stateWithUpdatedPrescriptionIds = updateAllCollectionsPadPrescriptionIds(
    intermediateState,
    validPrescriptions
  );

  return stateWithUpdatedPrescriptionIds;
};
